import styles from './index.module.sass';
import { useEffect, useState } from 'react';
import { useStore } from 'effector-react';
import classNames from 'classnames';

import {
  $moistureChangesDensity,
  $selectedRecipeStore,
  $sleeveToView,
  setMarkeredMixesToInitialState,
} from '../../store/recipes.store';
import {
  fetchAvailableBunkers,
  fetchTopRecipesForWarehouse,
  fetchWarehouseData,
} from '@/widgets/recipe/model';
import { MixesTab } from './components/mixes-tab';
import { LeftoversTab } from './components/leftovers-tab';
import { MixingModal } from './components/mixing-modal';
import { MainTab } from './components/main-tab/index.component';
import {
  $bestMarketPricesTab,
  getBestMarketPricesTabFx,
} from '../../store/analytical-mixing.store';

export const RecipeDetail = ({
  selectRecipeFoo,
  setDisplaySelect,
  mixingModal,
  setMixingModal,
  activeTab,
  setActiveTab,
  selectedRecipe,
  isSidebarVisible,
}: {
  selectRecipeFoo: (id: number) => void;
  setDisplaySelect: (val: boolean) => void;
  mixingModal: boolean;
  setMixingModal: (val: boolean) => void;
  activeTab: number;
  setActiveTab: (val: number) => void;
  selectedRecipe: number;
  isSidebarVisible: boolean;
}) => {
  const sleeveToViewId = useStore($sleeveToView);
  const activeRecipe = useStore($selectedRecipeStore);

  const moistureChangesDensity = useStore($moistureChangesDensity);
  const data = useStore($bestMarketPricesTab)?.find(
    (item) => item.id === activeRecipe?.id,
  );
  const [orderBy, setOrderBy] = useState('asc');
  // const [sorterOptions, setSorterOptions] = useState([
  //   {
  //     label: 'выгоде от микса',
  //     val: 'profit',
  //     active: true,
  //   },
  // ]);
  const [tabs, setTabs] = useState([
    { label: 'основные данные склада', id: 0 },
    { label: 'миксы пшеницы', id: 1, disabled: false },
    { label: 'остатки после миксования пшеницы', id: 2, disabled: false },
  ]);
  const [tabsActive, setTabsActive] = useState(false);

  useEffect(() => {
    if (sleeveToViewId) setActiveTab(0);

    getBestMarketPricesTabFx({ trade: true, moistureChangesDensity });
    return () => {};
  }, []);

  useEffect(() => {
    const fixedMixPrice = data?.mix_price?.toFixed(2);
    const fixedPrice = data?.price?.toFixed(2);
    //Блокируем до тех пор пока мы не разберемся с 6 цифрой 'стоимость склада при миксовании' в аналитическое миксование основные данные склада (выгода при одинаковых цифрах)
    // if (fixedMixPrice && fixedPrice && fixedMixPrice === fixedPrice) setActiveTab(0);
    if (activeRecipe?.actions) {
      fetchTopRecipesForWarehouse(Number(activeRecipe?.actions)); // id
      fetchAvailableBunkers();
      fetchWarehouseData(Number(activeRecipe?.actions));
    }
    setMarkeredMixesToInitialState();
  }, [activeRecipe, data]);

  useEffect(() => {
    let permission = false;
    data?.bags.map((item) => (item.mixes.length !== 0 ? (permission = true) : null));
    if (data) {
      setTabs([
        { label: 'основные данные склада', id: 0 },
        {
          label: 'миксы пшеницы',
          id: 1,
          disabled: !permission,
        },
        {
          label: 'остатки после миксования пшеницы',
          id: 2,
          disabled: !permission,
        },
      ]);
    }
  }, [data]);

  return (
    <div
      className={classNames(styles.root, isSidebarVisible && styles.sidebarExpanded)}
    >
      {activeTab === 0 ? (
        <MainTab
          selectRecipeFoo={selectRecipeFoo}
          tabs={tabs}
          setActiveTab={setActiveTab}
          activeTab={activeTab}
        />
      ) : activeTab === 1 ? (
        <MixesTab
          selectRecipeFoo={selectRecipeFoo}
          tabs={tabs}
          setActiveTab={setActiveTab}
          activeTab={activeTab}
        />
      ) : (
        <LeftoversTab
          selectRecipeFoo={selectRecipeFoo}
          tabs={tabs}
          activeTab={activeTab}
          setActiveTab={setActiveTab}
        />
      )}
      <MixingModal
        visible={mixingModal}
        setVisible={setMixingModal}
        setDisplaySelectBunker={setDisplaySelect}
        selectedRecipe={selectedRecipe}
      />
    </div>
  );
};
